"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
ProductBoxDirective.$inject = ['$rootScope'];
function ProductBoxDirective($rootScope) {
    return {
        scope: {
            product: '=',
            activeClass: '=',
            type: '='
        },
        template: require('./views/product-box.html'),
        link: function (scope, element, attrs, ngModel) {
            scope.show_vat = $rootScope.show_vat;
            $rootScope.$watch('show_vat', function (value) {
                scope.show_vat = $rootScope.show_vat;
            });
            scope.currency = $rootScope.currency;
            $rootScope.$watch('currency_value', function (value) {
                scope.currency = $rootScope.currency_value;
            });
            scope.show_prices = $rootScope.show_prices;
            $rootScope.$watch('show_prices', function (value) {
                scope.show_prices = $rootScope.show_prices;
            });
            if (scope.product.damaged_product) {
                scope.product.damaged_orginal_price = scope.product.price / (1 - scope.product.damage_discount_percentage / 100);
                scope.product.damaged_orginal_price_vat = scope.product.damaged_orginal_price + (scope.product.damaged_orginal_price * scope.product.vat) / 100;
            }
            scope.product.price_vat = scope.product.price + (scope.product.price * scope.product.vat) / 100;
            scope.product.price_discount_vat = parseInt(scope.product.price_discount) + (parseInt(scope.product.price_discount) * scope.product.vat) / 100;
        }
    };
}
exports.ProductBoxDirective = ProductBoxDirective;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/shop/directives/ProductBoxDirective.ts
// module id = 363
// module chunks = 0